export function formatPlate(plate: string): string {
  const cleaned = plate.toUpperCase().replace(/[^(0-9|A-Z)]/g, "");
  const lastDash = plate.slice(-1) === "-" ? "-" : "";

  if (cleaned.length > 2 && cleaned.match(/^[A-Z]{2}[0-9]/)) {
    return cleaned.replace(/(.{2})/, "$1-").slice(0, 7) + lastDash;
  }
  if (cleaned.length > 4 && cleaned.match(/^[A-Z]{4}[0-9]/)) {
    return cleaned.replace(/(.{4})/, "$1-").slice(0, 7) + lastDash;
  }
  return cleaned.slice(0, 6) + lastDash;
}
